import { registeredTabsHandlers } from '@/global/components/view-layouts/tabs-layout/common/registered-tabs-handlers'
import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { isObject, cloneDeep } from '@/global/utils/utils'
import { dateService, FORMATS } from '@/global/services/date'
import { api } from '@/global/services/api'

export default {
  methods: {
    showInspectionEdit (event) {
      const { setFormData } = registeredTabsHandlers?.inspections || {}
      const { data } = event || {}
      const clonedData = cloneDeep(data)
      const { showDetails, setDetailsTitle } = this.blockConfig || {}
      const appendToDetailsTitle = clonedData.inspection_date ? dateService.formatCustom(data.inspection_date, FORMATS.isoDate, FORMATS.date) : this.$t('fleet/vehicle.details')
      const detailsTitle = this.$t('fleet/vehicle.inspection') + ' - ' + appendToDetailsTitle

      if (typeof setFormData === 'function' && data && isObject(data)) {
        // convert dates for correct display
        clonedData.inspection_date = clonedData?.inspection_date ? dateService.formatCustom(data.inspection_date, FORMATS.isoDate, FORMATS.date) : null
        clonedData.valid_until = clonedData?.valid_until ? dateService.formatCustom(data.valid_until, FORMATS.isoDate, FORMATS.date) : null

        setDetailsTitle?.(detailsTitle)
        this.inspectionDetailsTitle = detailsTitle
        setFormData(clonedData)
      }

      showDetails?.()
      this.showInspectionsTable = false
      this.showInspectionsDetails = true
    },

    onInspectionActivation (event) {
      const { status, id, inspection_date: inspectionDate } = event?.data || {}
      if (!id) {
        return
      }
      const title = status ? this.$t('fleet/vehicle.inspection_deactivation_title') : this.$t('fleet/vehicle.inspection_activation_title')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (inspectionDate ? dateService.formatFromUtc(inspectionDate, FORMATS.date) : '/'))
      this.$set(this.informationDialogConfig, 'message', status ? this.$t('fleet/vehicle.inspection_deactivation_message') : this.$t('fleet/vehicle.inspection_activation_message'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.activationCallback(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async activationCallback (event) {
      try {
        const { id, status } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.inspections || {}
        const formData = new FormData()
        formData.append('_method', 'PATCH')
        formData.append('status', status ? 'false' : 'true')

        await api('fleet').post(`vehicle-inspection-status/${id}`, formData)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    onInspectionDelete (event) {
      const { id, inspection_date: inspectionDate } = event?.data || {}
      if (!id) {
        return
      }

      const title = this.$t('fleet/vehicle.inspection_delete_title')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (inspectionDate ? dateService.formatFromUtc(inspectionDate, FORMATS.date) : '/'))
      this.$set(this.informationDialogConfig, 'message', this.$t('fleet/vehicle.inspection_delete_message'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.deleteCallback(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async deleteCallback (event) {
      try {
        const { id } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.inspections || {}

        await api('fleet').delete(`vehicle-inspection/${id}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    async inspectionRemoveImageCallback (event) {
      try {
        const { module, route } = event?.removeApiConfig || {}
        const { uuid: imageUuid, tabKey } = event?.file || {}
        const { index } = event || {}
        const { fetchData } = registeredTableHandlers?.[tabKey] || {}

        if (module && route && imageUuid) {
          await api(module).delete(route + imageUuid)
          this.imagesPreviewDialogConfig.images = this.imagesPreviewDialogConfig.images.filter((_, i) => i !== index)
          if (typeof fetchData === 'function') {
            fetchData()
          }
        }
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
